










import { Component, Prop, Vue } from 'vue-property-decorator';
import { i18n } from '@/plugins/i18n/i18n';
import { TaskMetadataArgsLabel } from '@/types/type';

@Component
export default class TaskMetadataArgLabel extends Vue {
  @Prop()
  private labels!: TaskMetadataArgsLabel[];

  @Prop({ required: false, default: false })
  private isRequired!: boolean;

  private getLabel(): string {
    const labelItem = this.labels.find(label => label.language === i18n.locale);
    if (labelItem) {
      return labelItem.label;
    } else {
      const defaultLabelItem = this.labels.find(
        label => label.language === i18n.fallbackLocale
      );
      return defaultLabelItem ? defaultLabelItem.label : '';
    }
  }
}
